import { loadResourcesUtils } from "@ane/core/lib/utils/LoadResourcesUtils";
import { combineEpics } from "redux-observable";
import SubscriberResources from "@ane/exp-data/lib/resources/SubscriberResources";
const prefix = "LOAD_FEATURES_SUBSCRIBERS";
const args = {
  actionPrefix: prefix,
  reduxKeyNested: () => ["items"],
  loadResource: (payload) => {
    return SubscriberResources.getSubscriberDisplayNamesByEntities(payload);
  },
  onCompleteSuccess: (result, inputPayload) => {
    return result;
  }
};
const loadSubscriberDisplayNamesByEntitiesEpicReducer = loadResourcesUtils(args);
const epics = combineEpics(loadSubscriberDisplayNamesByEntitiesEpicReducer.epic);
export {
  epics as default,
  loadSubscriberDisplayNamesByEntitiesEpicReducer
};
//# sourceMappingURL=epics.js.map
